import { FieldType } from 'modules/domains';
import { useConditionComparatorController, useConditionValueController } from './form';
import { getDefaultComparator, getDefaultValue } from '../utils';

export const useResetConditionComparatorAndValue = () => {
  const {
    field: { onChange: onChangeComparator },
  } = useConditionComparatorController();
  const {
    field: { onChange: onChangeValue },
  } = useConditionValueController();
  return (fieldType: FieldType) => {
    onChangeComparator({ target: { value: getDefaultComparator(fieldType) } });
    onChangeValue({ target: { value: getDefaultValue(fieldType) } });
  };
};
